module.exports = __webpack_public_path__ + "171b9e1048ccb13d3c287b4f48ad767b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-steve-02.jpg
 ** module id = 372
 ** module chunks = 0
 **/